import React from 'react';

// Placeholder for StarIcon - replace with actual Heroicon or SVG
const StarIcon = ({ filled, className }) => (
  <span className={`inline-block w-5 h-5 ${filled ? 'text-yellow-400' : 'text-gray-300'} ${className}`}>
    ★
  </span>
);

const TestimonialCard = ({
  rating, // number 0-5
  reviewText,
  customerName,
  customerLocation, // e.g., "Houston, TX"
  reviewDate, // e.g., "May 2025"
  customerAvatar, // URL or path to image, or initials for placeholder
  servicePerformed, // e.g., "AC Repair"
}) => {
  const renderStars = () => {
    let stars = [];
    for (let i = 1; i <= 5; i++) {
      stars.push(<StarIcon key={i} filled={i <= rating} />);
    }
    return stars;
  };

  return (
    <div className="bg-white border border-gray-200 rounded-lg shadow-md hover:shadow-lg transition-shadow duration-300 ease-in-out flex flex-col p-6">
      {/* Rating */}
      <div className="flex items-center mb-3">
        {renderStars()}
      </div>

      {/* Review Text - consider a "Read More" for very long text */}
      <p className="text-base text-brand-gray italic mb-4 flex-grow">
        <span className="text-2xl text-gray-300 mr-1 leading-none select-none">“</span>
        {reviewText}
        <span className="text-2xl text-gray-300 ml-1 leading-none select-none">”</span>
      </p>

      {/* Customer Information */}
      <div className="mt-auto pt-4 border-t border-gray-100">
        <div className="flex items-center">
          {customerAvatar && (
            <img 
              src={customerAvatar} 
              alt={customerName} 
              className="w-10 h-10 rounded-full mr-3 object-cover bg-gray-200"
            />
            // Or for initials placeholder:
            // <div className="w-10 h-10 rounded-full bg-brand-accent text-white flex items-center justify-center mr-3 text-sm font-semibold">
            //   {customerName.split(' ').map(n => n[0]).join('')}
            // </div>
          )}
          <div>
            <p className="font-semibold text-brand-gray-dark text-sm">{customerName}</p>
            {customerLocation && <p className="text-xs text-gray-500">{customerLocation}</p>}
          </div>
        </div>
        {reviewDate && <p className="text-xs text-gray-400 mt-1">Reviewed: {reviewDate}</p>}
        {servicePerformed && (
          <span className="mt-2 inline-block bg-brand-green-lightest text-brand-green-dark text-xs font-semibold px-2 py-0.5 rounded-full">
            Service: {servicePerformed}
          </span>
        )}
      </div>
    </div>
  );
};

export default TestimonialCard; 